/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// open links in new tab - FJS
const links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
    }
}


// // Sticky header on scroll up - FJS
// let lastScrollTop = 0;
// const stickyDiv = document.querySelector(".shopify-section--header");
// const threshold = 5;

// window.addEventListener("scroll", function () {
//     let scrollTop = window.scrollY || document.documentElement.scrollTop;
//     if (Math.abs(scrollTop - lastScrollTop) < threshold) {
//         return; // Ignore minor scroll changes
//     }

//     if (scrollTop === 0) {
//         stickyDiv.classList.remove("header-sticky");
//     } else if (scrollTop < lastScrollTop) {
//         stickyDiv.classList.add("header-sticky");
//     } else {
//         stickyDiv.classList.remove("header-sticky");
//     }

//     lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
// });


// Sticky header on scroll up - FJS
let lastScrollTop = 0;
const stickyDiv = document.querySelector(".shopify-section--header");
const threshold = 5;
const topThreshold = 5;

window.addEventListener("scroll", function() {
    let scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (scrollTop < topThreshold) {
        stickyDiv.classList.remove("header-sticky");
        lastScrollTop = 0;
        return;
    }

    if (Math.abs(scrollTop - lastScrollTop) < threshold) {
        return; // Ignore minor scroll changes
    }

    if (scrollTop < lastScrollTop) {
        stickyDiv.classList.add("header-sticky");
    } else {
        stickyDiv.classList.remove("header-sticky");
    }

    lastScrollTop = scrollTop;
});

// Product Quantity + Add to Cart Block - Mobile Sticky Behavior
document.addEventListener('DOMContentLoaded', function() {
    const quantityAddCartBlock = document.querySelector('.product-quantity-add-cart-block--sticky-mobile[data-sticky-mobile]');
    if (quantityAddCartBlock) {
        // Check if we're on mobile
        const isMobile = window.innerWidth <= 740;
        if (isMobile) {
            // Show the block immediately when page loads
            quantityAddCartBlock.classList.add('is-visible');
        }
    }
});

// Shop Pay's Font remover
if (location.pathname.includes('/products/')) {
    function fix() {
        document.querySelectorAll('shopify-payment-terms').forEach(el => {
            if (el.shadowRoot) {
                el.shadowRoot.querySelectorAll('.font-system').forEach(e => e.classList.remove('font-system'));
            }
        });
    }

    document.addEventListener('DOMContentLoaded', fix);
    new MutationObserver(fix).observe(document.body, { childList: true, subtree: true });
}

// Collapse the dynamic checkout slot when wallets are missing or hidden by an app.
// Theme min-height + the payment-container grid gap otherwise leave a blank 48px row.
(function() {
    const EMPTY_CLASS = 'is-empty';
    const observedShadows = new WeakSet();
    let scheduled = false;
    let allowEmptyCollapse = false;

    function observeShadow(host) {
        if (!host.shadowRoot || observedShadows.has(host)) return;
        observedShadows.add(host);
        new MutationObserver(schedule).observe(host.shadowRoot, { childList: true, subtree: true });
    }

    function hasWalletUi(root) {
        if (!root) return false;
        if (root.querySelector('iframe')) return true;

        const hosts = root.querySelectorAll('shopify-accelerated-checkout, shopify-accelerated-checkout-cart');
        for (let i = 0; i < hosts.length; i++) {
            const host = hosts[i];
            observeShadow(host);
            if (!host.shadowRoot) continue;
            if (host.shadowRoot.querySelector('iframe, button, a, [role="button"]')) return true;
        }

        return false;
    }

    function isAppHidden(el) {
        const style = getComputedStyle(el);
        return style.visibility === 'hidden' || Number(style.opacity) === 0;
    }

    function sync() {
        scheduled = false;
        document.querySelectorAll('.shopify-payment-button').forEach(function(el) {
            const hide = isAppHidden(el) || (allowEmptyCollapse && !hasWalletUi(el));
            el.classList.toggle(EMPTY_CLASS, hide);
        });
    }

    function schedule() {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(sync);
    }

    function start() {
        schedule();
        setTimeout(function() {
            allowEmptyCollapse = true;
            schedule();
        }, 1500);
        ['shopify-accelerated-checkout', 'shopify-accelerated-checkout-cart'].forEach(function(name) {
            customElements.whenDefined(name).then(schedule).catch(function() {});
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }

    window.addEventListener('load', schedule);
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();

// FJS - PRODUCT QUANTITY SELECTOR - Hide/show quantity selector based on variant availability
document.addEventListener('DOMContentLoaded', function() {
    // Function to toggle quantity selector visibility
    function toggleQuantitySelector(variant) {
        const quantitySelectors = document.querySelectorAll('.product-quantity-add-cart-block__quantity');

        quantitySelectors.forEach(function(selector) {
            if (variant && variant.available) {
                selector.classList.remove('js-hide-quantity');
            } else {
                selector.classList.add('js-hide-quantity');
            }
        });
    }

    // Listen for variant changes on all product forms
    document.querySelectorAll('form[is="product-form"]').forEach(function(form) {
        form.addEventListener('variant:change', function(event) {
            toggleQuantitySelector(event.detail.variant);
        });
    });

    // Initialize on page load
    if (window.ProductLoader && window.productOptions) {
        // Get current product data
        const productForm = document.querySelector('form[is="product-form"]');
        const productHandle = productForm && productForm.getAttribute('data-product-handle');
        if (productHandle) {
            ProductLoader.load(productHandle).then(function(product) {
                const currentVariant = product.selected_or_first_available_variant;
                toggleQuantitySelector(currentVariant);
            });
        }
    } else {
        // Fallback for initial load
        const addToCartButtons = document.querySelectorAll('[data-product-add-to-cart-button]');
        addToCartButtons.forEach(function(button) {
            const isDisabled = button.hasAttribute('disabled');
            const quantitySelectors = document.querySelectorAll('.product-quantity-add-cart-block__quantity');

            quantitySelectors.forEach(function(selector) {
                if (isDisabled) {
                    selector.classList.add('js-hide-quantity');
                } else {
                    selector.classList.remove('js-hide-quantity');
                }
            });
        });
    }
});




// FJS - Pre-order confirmation popup in cart drawer
// Intercept checkout in capture phase so third-party apps (e.g. Discount Ninja)
// do not start their checkout flow until the shopper confirms.
function openPreorderModal(modal) {
    if (!modal || modal.dataset.preorderSuppress === 'true') return;
    // Use setAttribute instead of modal.open: the theme's open setter is async
    // and can re-open the modal after the shopper clicks "I AGREE".
    modal.setAttribute('open', '');
}

function closePreorderModal(modal) {
    if (!modal) return;
    modal.dataset.preorderSuppress = 'true';
    modal.removeAttribute('open');
}

document.addEventListener('click', function(event) {
    const checkoutButton = event.target.closest('#mini-cart .checkout-button[name="checkout"]');
    if (!checkoutButton) return;

    const cartDrawer = document.getElementById('mini-cart');
    if (!cartDrawer || cartDrawer.getAttribute('data-has-preorder') !== 'true') return;
    if (cartDrawer.dataset.preorderConfirmed === 'true') return;

    event.preventDefault();
    event.stopPropagation();

    openPreorderModal(document.getElementById('preorder-confirmation-modal'));
}, true);

document.addEventListener('click', function(event) {
    const confirmButton = event.target.closest('[data-action="preorder-confirm"]');
    if (!confirmButton) return;

    const cartDrawer = document.getElementById('mini-cart');
    const checkoutButton = cartDrawer && cartDrawer.querySelector('.checkout-button[name="checkout"]');
    const modal = document.getElementById('preorder-confirmation-modal');

    if (!checkoutButton || !modal) return;

    cartDrawer.dataset.preorderConfirmed = 'true';
    closePreorderModal(modal);

    // Re-trigger checkout so Discount Ninja and the native form flow run normally.
    checkoutButton.click();

    window.setTimeout(function() {
        delete modal.dataset.preorderSuppress;
    }, 1000);
});

document.addEventListener('submit', function(event) {
    const form = event.target;
    if (!form || form.id !== 'mini-cart-form') return;

    const cartDrawer = form.closest('cart-drawer');
    if (cartDrawer && cartDrawer.dataset.preorderConfirmed === 'true') {
        delete cartDrawer.dataset.preorderConfirmed;
    }
}, true);



// FJS — Re-fetch variant when Liquid auto-corrects downstream options after an upstream change
function getFjsActiveOptionValues(form) {
    return Array.from(form.elements)
        .filter(function(item) {
            return item.matches('input[data-option-position]:checked, input[data-option-position][type="hidden"]');
        })
        .filter(function(item) {
            return item.name && item.name.indexOf('option') !== -1;
        })
        .sort(function(a, b) {
            return parseInt(a.getAttribute('data-option-position'), 10) - parseInt(b.getAttribute('data-option-position'), 10);
        })
        .map(function(input) {
            return input.value;
        });
}

document.addEventListener('change', function(event) {
    var input = event.target;
    if (!input.matches('input[data-option-position]')) return;

    var picker = input.closest('variant-picker');
    if (picker) {
        picker.removeAttribute('data-fjs-resync-attempted');
    }
});

document.addEventListener('product:rerender', function(event) {
    var form = event.target;
    if (!form || !form.matches('form[is="product-form"]')) return;

    var picker = form.querySelector('variant-picker');
    if (!picker) return;

    queueMicrotask(function() {
        if (picker.dataset.fjsResyncing === '1') return;
        if (picker.dataset.fjsResyncAttempted === '1') return;

        var optionValues = getFjsActiveOptionValues(form);
        if (!optionValues.length) return;

        var variantScript = picker.querySelector('script[data-variant]');
        var variantData = JSON.parse(variantScript && variantScript.textContent ? variantScript.textContent : '{}');
        var needsResync = !variantData || !variantData.id || variantData.available === false;

        if (!needsResync) return;

        picker.dataset.fjsResyncing = '1';
        picker.dataset.fjsResyncAttempted = '1';
        Promise.resolve(picker.selectCombination({
            optionValues: optionValues,
            productChange: false
        })).finally(function() {
            delete picker.dataset.fjsResyncing;
        });
    });
});

// FJS - STOCK RESERVE - Keep the PDP quantity input within the units actually for sale.
// Liquid renders the initial max, but the input sits outside product-payment-container, so a
// partial re-render leaves a stale max behind on variant change. fjs_sellable is injected into
// the variant JSON by product-form.liquid; null means the variant has no finite tracked quantity.
document.addEventListener('variant:change', function(event) {
    const variant = event.detail && event.detail.variant;
    if (!variant) return;

    let limit = typeof variant.fjs_sellable === 'number' ? Math.max(variant.fjs_sellable, 1) : null;
    const ruleMax = variant.quantity_rule && typeof variant.quantity_rule.max === 'number' ?
        variant.quantity_rule.max :
        null;

    if (ruleMax !== null) {
        limit = limit === null ? ruleMax : Math.min(limit, ruleMax);
    }

    const inputs = document.querySelectorAll(
        '.product-quantity-add-cart-block__quantity .quantity-selector__input, .product-form__quantity .quantity-selector__input'
    );

    inputs.forEach(function(input) {
        if (limit === null) {
            input.removeAttribute('max');
            return;
        }

        input.setAttribute('max', String(limit));

        // The new variant may allow fewer units than the shopper already picked
        if (parseInt(input.value, 10) > limit) {
            input.value = String(limit);
            input.style.setProperty('--quantity-selector-character-count', input.value.length + 'ch');
        }
    });
});

// FJS - STOCK RESERVE - Bring the cart back within the units actually for sale.
// The cart Liquid renders max="" with the reserve already deducted, so any line holding more than
// that (repeated adds, or a reserve raised after the item was in the cart) is clamped here. We go
// through the theme's own change flow by setting the input and firing 'change', which line-item-quantity
// already listens to, so the drawer re-render and the cart page redirect keep working as usual.
(function() {
    const ATTEMPT_KEY = 'fjsCartLimitAttempts';
    const MAX_ATTEMPTS = 6;
    let pending = false;

    function readAttempts() {
        try {
            return parseInt(sessionStorage.getItem(ATTEMPT_KEY), 10) || 0;
        } catch (error) {
            return 0;
        }
    }

    function writeAttempts(value) {
        try {
            if (value === null) {
                sessionStorage.removeItem(ATTEMPT_KEY);
            } else {
                sessionStorage.setItem(ATTEMPT_KEY, String(value));
            }
        } catch (error) {
            // Private browsing: the in-memory guard below still prevents a runaway loop
        }
    }

    function enforceCartLimits() {
        // Survives the full page reload the cart page does on every quantity change
        if (pending || readAttempts() >= MAX_ATTEMPTS) return;

        const inputs = document.querySelectorAll('input[name="updates[]"][max][data-line]');

        for (const input of inputs) {
            const max = parseInt(input.getAttribute('max'), 10);
            const quantity = parseInt(input.value, 10);

            if (isNaN(max) || isNaN(quantity) || quantity <= max) continue;

            // One line per pass: correcting it re-renders the cart and recalculates the rest
            pending = true;
            writeAttempts(readAttempts() + 1);
            input.value = String(Math.max(max, 0));
            input.dispatchEvent(new Event('change', { bubbles: true }));
            return;
        }

        writeAttempts(null);
    }

    document.documentElement.addEventListener('line-item-quantity:change:end', function() {
        pending = false;
    });

    document.addEventListener('DOMContentLoaded', function() {
        enforceCartLimits();

        const cartDrawer = document.getElementById('mini-cart');
        if (!cartDrawer) return;

        // The drawer swaps its innerHTML after each refresh, so watch instead of guessing a delay
        let debounce = null;
        new MutationObserver(function() {
            clearTimeout(debounce);
            debounce = setTimeout(enforceCartLimits, 150);
        }).observe(cartDrawer, { childList: true, subtree: true });
    });
})();

// FJS - STOCK RESERVE - Revalidate the cart against live stock right before handing off to checkout.
// The cart is only clamped while it renders, so a tab left open long enough can walk into the reserve.
// Here we re-render the cart section server-side (the same request the drawer uses, so all the reserve
// logic stays in Liquid), clamp whatever no longer fits, and ask the shopper to confirm the corrected
// cart instead of dead-ending them.
// This runs alongside the pre-order interceptor above rather than instead of it: both listen on
// document, so every click reaches both. Each blocks the submit for its own reason and re-triggers the
// button once satisfied, so a pre-order cart gets revalidated again after the shopper confirms.
(function() {
    const RELOAD_NOTICE_KEY = 'fjsStockAdjustedNotice';

    function notify(message) {
        if (!message) return;

        document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show', {
            bubbles: true,
            cancelable: true,
            detail: { status: 'error', error: message }
        }));
    }

    // A drawer re-render swaps the pre-order modal for a freshly rendered, closed copy, so one left
    // open would simply vanish mid-flow. Close it ourselves before refreshing. We deliberately skip
    // the preorderSuppress flag so it opens again on the next click, once the cart is settled.
    function closePreorderModalBeforeRerender() {
        const modal = document.getElementById('preorder-confirmation-modal');
        if (modal) modal.removeAttribute('open');
    }

    async function clampCartToStock() {
        const routes = window.themeVariables && window.themeVariables.routes;
        if (!routes) return false;

        const response = await fetch(routes.cartUrl + '?section_id=mini-cart');
        if (!response.ok) return false;

        const markup = new DOMParser().parseFromString(await response.text(), 'text/html');
        const overflow = [];

        markup.querySelectorAll('input[name="updates[]"][max][data-fjs-key]').forEach(function(input) {
            const max = parseInt(input.getAttribute('max'), 10);
            const quantity = parseInt(input.getAttribute('value'), 10);

            if (!isNaN(max) && !isNaN(quantity) && quantity > max) {
                overflow.push({ key: input.getAttribute('data-fjs-key'), quantity: Math.max(max, 0) });
            }
        });

        if (overflow.length === 0) return false;

        let cart = null;

        // Address lines by key, not by index: dropping one to zero renumbers every line after it
        for (const line of overflow) {
            const changed = await fetch(routes.cartChangeUrl + '.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: line.key, quantity: line.quantity, sections: ['mini-cart'] })
            });

            if (changed.ok) cart = await changed.json();
        }

        if (!cart) return false;

        closePreorderModalBeforeRerender();

        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
        return true;
    }

    document.addEventListener('click', async function(event) {
        const button = event.target.closest('.checkout-button[name="checkout"]');
        if (!button) return;

        if (button.dataset.fjsStockChecked === 'true') {
            delete button.dataset.fjsStockChecked;
            return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        let adjusted = false;

        try {
            adjusted = await clampCartToStock();
        } catch (error) {
            // Network trouble: Shopify's checkout is still the hard floor, so never block the sale
            adjusted = false;
        }

        if (adjusted) {
            const message = button.getAttribute('data-fjs-stock-message');
            const pageType = window.themeVariables && window.themeVariables.settings ?
                window.themeVariables.settings.pageType :
                null;

            if (pageType === 'cart') {
                // The cart page has no live re-render, so reload the way the theme does elsewhere
                try { sessionStorage.setItem(RELOAD_NOTICE_KEY, message || ''); } catch (storageError) {}
                window.location.reload();
            } else {
                notify(message);
            }

            return;
        }

        button.dataset.fjsStockChecked = 'true';
        button.click();
    }, true);

    document.addEventListener('DOMContentLoaded', function() {
        let message = null;

        try {
            message = sessionStorage.getItem(RELOAD_NOTICE_KEY);
            sessionStorage.removeItem(RELOAD_NOTICE_KEY);
        } catch (error) {
            return;
        }

        notify(message);
    });
})();

// FJS - DISCOUNT NINJA - Announce product cards the theme injects after page load.
// product-recommendations, cart-drawer-recommendations and recently-viewed-products all fetch their
// markup and swap it in with innerHTML, so Discount Ninja's own scan can finish before those cards
// exist and they end up with no strikethrough price and no badge. Whether it wins or loses that race
// depends on timing (a warm-cache reload loses it), which is why the loss looked intermittent.
// 'la:dn:collection:updated' is the event DN documents for dynamically added collection products.
(function() {
    const CONTAINER_SELECTOR = 'product-recommendations, cart-drawer-recommendations, recently-viewed-products';
    const CARD_SELECTOR = '[data-limoniapps-discountninja-product-handle]';

    let debounce = null;
    let waitingForApi = false;

    function announce() {
        const apiReady = typeof discountNinja !== 'undefined' && typeof discountNinja.api !== 'undefined';

        if (!apiReady) {
            // The injection beat the app script itself: replay once the API comes up
            if (waitingForApi) return;

            waitingForApi = true;
            document.addEventListener('la:dn:api:ready', function() {
                waitingForApi = false;
                announce();
            }, { once: true });

            return;
        }

        document.dispatchEvent(new CustomEvent('la:dn:collection:updated'));
    }

    // DN rewrites the price inside each card, so match on whole cards, never on their contents:
    // anything looser would make DN's own output re-trigger this observer.
    function addsCardToRecommendations(mutation) {
        for (const node of mutation.addedNodes) {
            if (node.nodeType !== Node.ELEMENT_NODE) continue;

            const cards = node.matches(CARD_SELECTOR) ? [node] : node.querySelectorAll(CARD_SELECTOR);

            for (const card of cards) {
                if (card.closest(CONTAINER_SELECTOR)) return true;
            }
        }

        return false;
    }

    new MutationObserver(function(mutations) {
        for (const mutation of mutations) {
            if (!addsCardToRecommendations(mutation)) continue;

            clearTimeout(debounce);
            debounce = setTimeout(announce, 100);
            return;
        }
    }).observe(document.documentElement, { childList: true, subtree: true });
})();

// Smooth-scroll review stars to the Judge.me widget instead of jumping.
// Capture phase so Judge.me's own badge click does not instant-jump first.
(function() {
    const HASH = '#judgeme_product_reviews';

    document.addEventListener('click', function(event) {
        const link = event.target.closest('a[href*="' + HASH + '"]');
        if (!link) return;

        const url = new URL(link.href, window.location.origin);
        if (url.pathname !== window.location.pathname) return;

        const target = document.getElementById('judgeme_product_reviews');
        if (!target) return;

        event.preventDefault();
        event.stopPropagation();

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({
            behavior: prefersReducedMotion ? 'auto' : 'smooth',
            block: 'start'
        });
    }, true);
})();